const nestedDialogOpen = "data-nested-dialog-open";
export {
  nestedDialogOpen
};
//# sourceMappingURL=DialogPopupDataAttributes.js.map
